export default __webpack_public_path__ + "static/Mobile-01 1-3f3f3aa0ed3b3d7bf8a459a9c2b1e955.png";